import React from 'react';
import PropTypes from 'prop-types';
import { tracksColors } from "../../config/styles";
import { AppContext } from "../../App";
import { TRACK_STATE_DIFFICULTY } from "../../config/constants";

function CrossRoad({ coords = '2401.000000, 588.000000', color = tracksColors.blue, forDebug }) {


	return (
		<AppContext.Consumer>
			{({ tracksState }) => {
				const customColor = tracksState === TRACK_STATE_DIFFICULTY ? color : tracksColors.open;
				return (
					<g id="crossroad" transform={`translate(${coords})`}>
						<circle fill={forDebug ? '#ccc' : customColor} cx="7" cy="7" r="5"/>
						<circle fill={forDebug ? '#ddd' : "#fff"} cx="7" cy="7" r="3"/>
					</g>
				)
			}}
		</AppContext.Consumer>
	)
}

CrossRoad.propTypes = {
	coords: PropTypes.string,
	color: PropTypes.string,
	forDebug: PropTypes.bool
};

export default CrossRoad;
